// SearchInput — search-styled Input with leading magnifying glass
// and a clear (×) affordance.

import { forwardRef } from 'react'

const SearchInput = forwardRef(function SearchInput(
  { value = '', onChange, onClear, placeholder = 'Search…', ...rest },
  ref
) {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <span
        aria-hidden
        style={{
          position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
          color: 'var(--olv-text-tertiary)', display: 'flex', alignItems: 'center',
          pointerEvents: 'none',
        }}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.4" />
          <path d="M9.5 9.5l3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </span>
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: '9px 36px 9px 36px',
          background: 'rgba(12,12,20,0.6)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 'var(--olv-radius-card)',
          color: 'var(--olv-text-primary)',
          fontSize: 12,
          fontFamily: 'var(--font-body)',
          outline: 'none',
          backdropFilter: 'blur(8px)',
        }}
        {...rest}
      />
      {value && onClear && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={onClear}
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: 'var(--olv-text-tertiary)',
            cursor: 'pointer',
            fontSize: 14,
            padding: 2,
          }}
        >
          ×
        </button>
      )}
    </div>
  )
})

export default SearchInput
